import { useEffect } from "react";
import FormInputs from '../CreateFormInput.js'
import useFormContext from "./useGetFormContext.js"
import Footer from '../Footer.js'
import Header from '../Header.js'
import RequestHeader from '../ResponsiveEvent.jsx/RequestHeader.js'
import { Navigation } from '../ResponsiveEvent.jsx/Navigation'

const GetEventDetail = () => {

    const { eventFormData, setRequestedBy, getEventById, setFirstGet,handlepageChange, headerRefresh } = useFormContext()

    useEffect(() => {
        if (eventFormData.requestedBy != "") {
            setRequestedBy();
        }

        var res = window.location.href.split('/');
        eventFormData.eventId = res[res.length - 1]
        getEventById(eventFormData.eventId)
        setFirstGet(true);
        if (res[res.length - 2] == 'guest') {
            handlepageChange(2);
        } else
        if (res[res.length - 2] == 'comment') {
            handlepageChange(3);
        } else
        if (res[res.length - 2] == 'postevent') {
            handlepageChange(4);
        }
    }, []);

    const content = (
        <form id="createNewRequestForm" className="form flex-col">
            <div>
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet"
                    integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossOrigin="anonymous">
                </link>
                <div className='container-fluid-custom'>
                    <Header key={headerRefresh} />
                    <RequestHeader />
                    <div className="container-fluid">
                        <div className="row m-1 mb-5">
                            <div className="col-md-2 p-0">
                                <Navigation />
                            </div>
                            <FormInputs />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </form>
    )

    return content
}

export default GetEventDetail